import { render, staticRenderFns } from "./LinkedSchoolBankAccount.vue?vue&type=template&id=d67c583e&scoped=true"
import script from "./LinkedSchoolBankAccount.vue?vue&type=script&lang=js"
export * from "./LinkedSchoolBankAccount.vue?vue&type=script&lang=js"
import style0 from "./LinkedSchoolBankAccount.vue?vue&type=style&index=0&id=d67c583e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c583e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d67c583e')) {
      api.createRecord('d67c583e', component.options)
    } else {
      api.reload('d67c583e', component.options)
    }
    module.hot.accept("./LinkedSchoolBankAccount.vue?vue&type=template&id=d67c583e&scoped=true", function () {
      api.rerender('d67c583e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/LinkedSchoolBankAccount.vue"
export default component.exports